var map = {
	"./add.lox": 962,
	"./block.lox": 396,
	"./break.lox": 206,
	"./continue.lox": 788,
	"./flow.lox": 364,
	"./for.lox": 358,
	"./fun.lox": 580,
	"./hello_world.lox": 146,
	"./var_add.lox": 300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 531;